/**
 * Cadence d'interrogation de la page de suivi de commande.
 *
 * Mesure prod du 2026-09-01 (journal de bord Traefik, fenêtre de 15 h) : une
 * seule adresse a émis **2 744** requêtes `/sale/order/order/<uuid>/` pour une
 * seule commande, soit une toutes les ~20 s sans interruption, bien après que
 * la commande a été remise. Le client avait fermé son téléphone ; l'onglet,
 * lui, continuait.
 *
 * L'arrêt sur statut terminal existait déjà — il ne suffit pas : le statut
 * n'atteint `ready` / `handed_over` que si le restaurant l'avance, et beaucoup
 * de commandes restent `received` pour toujours. Il faut donc une cadence qui
 * s'essouffle d'elle-même, et une fin.
 *
 * Ce bruit-là n'est pas gratuit : il tombe sur le même daphne qui sert les
 * photos du menu et le flux d'impression, aux heures de service.
 */

/** Paliers cumulés depuis l'ouverture de la page. Au-delà du dernier : arrêt. */
export const TRACKING_POLL_STEPS: ReadonlyArray<{ untilMs: number; intervalMs: number }> = [
  // Les premières minutes sont les seules où le statut bouge vite (paiement
  // encaissé, commande acceptée) : on garde la cadence d'origine.
  { untilMs: 2 * 60_000, intervalMs: 5_000 },
  { untilMs: 10 * 60_000, intervalMs: 30_000 },
  { untilMs: 2 * 60 * 60_000, intervalMs: 120_000 },
];

/** Interrogation à cet instant, en ms. `0` = ne plus interroger du tout. */
export function trackingPollIntervalMs(elapsedMs: number): number {
  const step = TRACKING_POLL_STEPS.find((candidate) => elapsedMs < candidate.untilMs);
  return step ? step.intervalMs : 0;
}

/**
 * Délai avant le prochain changement de cadence, en ms. `null` quand il n'y en
 * a plus (la dernière étape est l'arrêt définitif).
 */
export function msUntilNextPollStep(elapsedMs: number): number | null {
  const next = TRACKING_POLL_STEPS.find((candidate) => elapsedMs < candidate.untilMs);
  return next ? next.untilMs - elapsedMs : null;
}
